// extracted by mini-css-extract-plugin
module.exports = {"item":"_4dd39ddf","link":"_758480a","image":"_532be84d","imageCopy":"_1ca7a2a8","shimmerLoadingBackground":"_c43cd5a7"};